import { AddrType } from '@/services/apis/address/models'
import i18n from '@/services/i18n'

const { t } = i18n

export const addrTypeList: { type: AddrType; name: string }[] = [
  { type: 'P2PKH_CASH', name: t('wallet.address.cashAddr') },
  { type: 'P2PKH', name: t('wallet.address.normalAddr') },
  { type: 'P2WPKH', name: t('wallet.address.segwitAddr') },
]

export const getAddrTypeName = (type?: AddrType) => {
  if (!type) {
    return
  }
  return addrTypeList.find(item => item.type === type)?.name
}

export const maskAddress = (address: string, showLen = 8) => {
  const before = address.slice(0, showLen)
  const after = address.slice(-showLen)
  return `${before}***${after}`
}
